"use client"

import { Navigate } from "react-router-dom"

export default function DocumentationPage(){
    return <Navigate to="/documentation/1" replace />;
}